import { createSlice } from "@reduxjs/toolkit";

// Load from localStorage if exists
const persistedAccount = JSON.parse(localStorage.getItem("userAccount")) || {};
const persistedBusiness =
  JSON.parse(localStorage.getItem("selectedBusiness")) || {};
// const completeInfo = localStorage.getItem("completeInfo");

const accountSlice = createSlice({
  name: "account",
  initialState: {
    urn: persistedAccount.urn || null,
    slug: persistedAccount.slug || null,
    name: persistedAccount.name || null,
    extraData: persistedAccount.extraData || null,
    clientUrn: persistedAccount.clientUrn || null,
    businessUrn: persistedBusiness.businessUrn || null,
    businessSlug: persistedBusiness.businessSlug || null,
    // completeInfo: completeInfo,
  },
  reducers: {
    setSelectedAccount(state, action) {
      const { urn, slug, name, extraData, clientUrn } = action.payload;
      state.urn = urn;
      state.slug = slug;
      state.name = name;
      state.extraData = extraData;
      state.clientUrn = clientUrn;

      // Save to localStorage
      localStorage.setItem(
        "userAccount",
        JSON.stringify({ urn, slug, name, extraData, clientUrn }),
      );
    },
    clearSelectedAccount(state) {
      state.urn = null;
      state.slug = null;
      state.name = null;
      state.extraData = null;
      state.clientUrn = null;
      state.businessUrn = null;
      state.businessSlug = null;

      // Clear from localStorage
      localStorage.removeItem("userAccount");
      localStorage.removeItem("selectedBusiness");
    },
    updateBusinessUrn(state, action) {
      const { businessUrn, businessSlug } = action.payload;
      state.businessSlug = businessSlug;
      state.businessUrn = businessUrn;

      // Save to localStorage
      localStorage.setItem(
        "selectedBusiness",
        JSON.stringify({ businessUrn, businessSlug }),
      );
    },
    // setCompleteInfo: (state, action) => {
    //   state.completeInfo = action.payload;
    //   localStorage.setItem("completeInfo", action.payload);
    // },
  },
});

// Export actions
export const {
  setCompleteInfo,
  setSelectedAccount,
  clearSelectedAccount,
  updateBusinessUrn,
} = accountSlice.actions;

// Export reducer
export default accountSlice.reducer;
